import NewsLp from './NewsLp'

export default NewsLp
